import { useCreateBreakdownDocument } from '@/hooks/useBreakdownDocuments';
import { NameTagDialog } from './NameTagDialog';

export interface SaveAsDialogProps {
  jobId: string;
  // The doc currently open in the editor. Used as sourceDocumentId so the
  // new doc starts with the same line items the user just saw. null when
  // creating a blank doc (e.g. "New version" button on the list view).
  source: { id: string; name: string } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  // Wrapper uses this to navigate to ?docId=<new>. Save As navigates because
  // the mental model is "I'm now editing this new draft."
  onCreated?: (doc: { id: string; name: string }) => void;
}

export function SaveAsDialog({
  jobId,
  source,
  open,
  onOpenChange,
  onCreated,
}: SaveAsDialogProps) {
  const createDoc = useCreateBreakdownDocument(jobId);

  return (
    <NameTagDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Save as new version"
      description={
        source ? (
          <>
            Create a new editable version starting from{' '}
            <strong>{source.name}</strong>. You'll be switched to it after
            it's created.
          </>
        ) : (
          'Create a new editable version.'
        )
      }
      submitLabel="Create version"
      submittingLabel="Creating..."
      includeTag
      onSubmit={async ({ name, tag }) => {
        const doc = await createDoc.mutateAsync({
          name,
          tag,
          sourceDocumentId: source?.id,
        });
        onCreated?.({ id: doc.id, name: doc.name });
      }}
    />
  );
}
